'use client';

import { SelectInput, useField, useFormFields, useTranslation } from '@payloadcms/ui';
import { TextFieldClientProps } from 'payload';
import * as React from 'react';
import { KbFileNoToolOption } from '../../api/consts';
import { AppToolOption } from '../../api/types';

type ToolOption = {
  label: string;
  value: string;
};

export const AppTool: React.FC<TextFieldClientProps> = ({ path = '', field }) => {
  const { t } = useTranslation<any, any>();
  const llmApp = useFormFields(([fields]) => fields['llmApp']);
  const { value, setValue } = useField<string>({ path });
  const [options, setOptions] = React.useState<ToolOption[]>([]);

  const llmAppValue = llmApp?.value;

  React.useEffect(() => {
    const fetchOptions = async () => {
      try {
        const url = `${process.env.PAYLOAD_PUBLIC_BASE_PATH || ''}/api/llm/appTools?llmApp=${llmAppValue}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const toolsOpts = (await response.json()) as AppToolOption[];
          toolsOpts.unshift({
            label: t('general:kbFileNoToolOption'),
            value: KbFileNoToolOption,
          });
          setOptions(toolsOpts);
          if (toolsOpts.length == 2) {
            // if there is only one tool, select it
            setValue(toolsOpts[1]!.value);
          } else if (!toolsOpts.some((option) => option.value === value)) {
            // reset selected value if it's not in the new options
            setValue(toolsOpts[0]!.value);
          }
        } else {
          setOptions([{ label: (await response.json()).message, value: '' }]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (llmAppValue) {
      fetchOptions();
    }
  }, [llmAppValue]);

  console.log('options: ', options);

  return (
    options?.filter((option) => option.value !== '').length !== 0 && (
      <div className="field-type select">
        <label
          className="field-label"
          htmlFor={`field-${path}`.replace(/\./g, '__')}
        >
          App tool
        </label>
        <SelectInput
          path={path}
          name={path}
          options={options}
          value={value}
          onChange={(option) => Array.isArray(option) ? null : setValue(option.value)}
          readOnly={field.admin?.readOnly}
        />
      </div>
    )
  );
};
